import { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import { useFetchBuildingServiceZoneReportQuery } from 'store/apis';
import { selectCurrentUserInfo } from 'store/slices';
import { useAppSelector } from 'store/store.hook';

type UseServiceZoneReportProps = {
  buildingId: number;
  start: string;
  end: string;
};

export const useServiceZoneReport = ({ buildingId, start, end }: UseServiceZoneReportProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [thumbnailBuffer, setThumbnailBuffer] = useState<any>(null);

  const {
    data = {},
    isFetching: fetching_BuildingServiceZoneReport,
    ...rest
  } = useFetchBuildingServiceZoneReportQuery({ orgSlug, id: buildingId, start, end }, { skip: !orgSlug });

  const {
    companyInfo: { title: organization = '', address = '', city = '', state = '', zip = '' } = {},
    buildingSummary: {
      basicZones = 0,
      feedback = 0,
      floors = 0,
      premiumZones = 0,
      services = 0,
      thumbnailUrl = null,
      workOrders = 0,
    } = {},
    serviceDate = [dayjs(new Date(start)).format('YYYY-MM-DD'), dayjs(new Date(end)).format('YYYY-MM-DD')],
    zones = [],
  } = data;

  const fetchImage = async (thumbnailUrl: string) => {
    try {
      const data = await fetch(thumbnailUrl, {
        credentials: 'include',
      });

      const blob = await data.blob();

      const reader = new FileReader();

      reader.readAsDataURL(blob);

      reader.onloadend = () => {
        const base64data = reader.result;
        setThumbnailBuffer(base64data);
        setIsLoading(false);
      };
    } catch (error) {
      console.error('Fetching building image has been failed => ', error);
      setThumbnailBuffer('');
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (fetching_BuildingServiceZoneReport) {
      setIsLoading(true);
    } else if (thumbnailUrl) {
      fetchImage(thumbnailUrl);
    } else {
      setThumbnailBuffer('');
      setIsLoading(false);
    }
  }, [fetching_BuildingServiceZoneReport, thumbnailUrl]);

  const building = { organization, address, city, state, zip };

  const buildingSummary = {
    basicZones,
    feedback,
    floors,
    premiumZones,
    services,
    thumbnailUrl: thumbnailBuffer,
    workOrders,
  };

  console.log({ building, buildingSummary, serviceDate, zones });

  return {
    data: { building, buildingSummary, serviceDate, zones },
    ...rest,
    isLoading,
    isFetching: fetching_BuildingServiceZoneReport,
  };
};
